module.exports = __webpack_public_path__ + "static/media/bgFeatures.ebffc661.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bgFeatures.jpg
// module id = 345
// module chunks = 0